import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, Platform, LoadingController, ModalController, AlertController } from 'ionic-angular';

import { HomePage } from '../home/home';
import { FilterPage } from '../filter/filter';
import { Devices, Tools } from '../../providers';

import { BackgroundMode } from '@ionic-native/background-mode';
import { LocalNotifications } from '@ionic-native/local-notifications';
import { Insomnia } from '@ionic-native/insomnia';
import { AppMinimize } from '@ionic-native/app-minimize';

declare var window:any;
declare var navigator:any;

@IonicPage()
@Component({
  selector: 'page-lista',
  templateUrl: 'lista.html',
})

export class ListaPage {
  busca:string='';
  renders:any;
  lista:any;
  devicesorig:any;
  devices:any;
  selecionados:number
  renderzero:object
  readyForeground:boolean=true;
  internalIntent:any;
  loopBack:any;
  count:number=0;
  loading:any;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public devicesApi: Devices,
    public tools: Tools,
    public platform: Platform,
    private backgroundMode: BackgroundMode,
    private localNotifications: LocalNotifications,
    private insomnia: Insomnia,
    private appMinimize: AppMinimize,
    public loadingCtrl: LoadingController,
    public modalCtrl: ModalController,
    public alertCtrl: AlertController
  ) {

    this.startHome();
    this.checkDevice();
    setInterval(()=>{
      let self = this;
      this.startHome();
    },1000*60*30);
  }

  rev(){
    this.tools.showAlert('toast','Versão 3.0.3');
  }

  openFilter() {
    let alertFabricante = this.alertCtrl.create();
    alertFabricante.setTitle('Selecione o fabricante:');

    let alertModelo = this.alertCtrl.create();
    alertModelo.setTitle('Selecione o modelo:');

    for(var x1 of this.lista){
      alertFabricante.addInput({type:'radio', label:x1.marca.toUpperCase(), value:x1.marca.toUpperCase(), checked:false});
    }

    // alertFabricante.addButton('Cancelar');
    alertFabricante.addButton({
      text: 'OK',
      handler: fabricante => {
        var x1 = this.lista.find((e,i)=>{
          if(e.marca == fabricante){
            e.i1 = i;
          }
          return e.marca == fabricante;
        });
        for(var aparelho of x1.aparelhos){
          alertModelo.addInput({type:'radio', label:aparelho.title.toUpperCase(), value:aparelho.title.toUpperCase(), checked:false});
        }

        alertModelo.addButton({
          text: 'OK',
          handler: modelo => {
            console.log(x1);
            var x2 = x1.aparelhos.find((e,i)=>{
              if(e.title.toUpperCase() == modelo){
                e.i2 = i
              }
              return e.title.toUpperCase() == modelo;
            });
            this.selectDev(x2, x1.i1,x2.i2);
          }
        });

        alertModelo.present();

      }
    });
    alertFabricante.present();
  }

  filter(event){
    let aparelhos:any;
    if(this.busca=='' || !this.busca){aparelhos=this.devicesorig}
    else{
      aparelhos = this.devicesorig.filter(item=>{
        return (item.filter).toLowerCase().indexOf(this.busca.toLowerCase()) > -1;
      });
    }

    this.changeItem(aparelhos);
  }

  startHome(){
    this.loading = this.loadingCtrl.create({content: "Carregando Aparelhos..."});
    this.loading.present();

    this.loadInit();

    this.renders = [
      {title:'Selecionar',renderimg:'assets/renders/grayphone.png'},
      {title:'Selecionar',renderimg:'assets/renders/grayphone.png'},
      {title:'Selecionar',renderimg:'assets/renders/grayphone.png'}
    ];

    this.renderzero = {title:'Selecionar',renderimg:'assets/renders/grayphone.png'};
    this.selecionados = 0;

    var off = this.devicesApi.getData('off');

    off = off.map(e=>{
      e.base64 = 'assets/renders2/'+e.modelo+'.png';
      return e;
    });

    console.log(off);

    this.devicesApi.getDevices((resp) => {
      console.log(resp);
      if(resp.status){
        this.tools.showAlert('toast','Aparelhos carregados com sucesso. [200]');

        var newdata = this.tratData(resp.data);
        this.devicesorig = newdata.concat([]);
        this.changeItem(newdata);
      }else{
        this.tools.showAlert('toast','Aparelhos novos não encontrados. [500]');

        let newdata = this.tratData(off);
        this.devicesorig = newdata.concat([]);
        this.changeItem(newdata);
      }
      this.loading.dismiss();
    });
  }

  checkDevice(){
    if( navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i)|| navigator.userAgent.match(/iPhone/i)|| navigator.userAgent.match(/iPad/i)|| navigator.userAgent.match(/iPod/i)|| navigator.userAgent.match(/BlackBerry/i)|| navigator.userAgent.match(/Windows Phone/i)){
      let alert = this.alertCtrl.create({
        title: 'Sugestão',
        message: 'Utilize o dispositivo na horizontal para ter uma experiência melhor!',
        buttons: [
          {
            text: 'Ok',
            handler: () => {}
          }
        ]
      });
      alert.present();
    }
  }

  tratData(data:any){
    var ordem = this.devicesApi.getData('ordem');
    var newdata = [];
    for(var item of data){
      var idx = ordem.findIndex(e=>e.toLowerCase().trim() == item.modelo.toLowerCase().trim());
      var obj = {
        "lancamento":item.lancamento || '',
        "oferta":item.oferta || '',
        "title":item.modelo || '',
        "create":item.create || '',
        "renderimg":item.base64 || '',
        "filter":item.fabricante+' '+item.modelo || '',
        "marca":item.fabricante || '',
        "feature1":item.display || '',
        "feature2":item.camera || '',
        "feature3":item.processador || '',
        "feature4":item.memoriaRam || '',
        "feature5":item.memoriaInt || '',
        "feature6":item.bateria || '',
        "feature7":item.versao || '',
        "order":idx==-1?50:idx
      }
      newdata.push(obj);
    }

    return newdata;
  }

  changeItem(aparelhos:any){
    console.log('aparelhos',aparelhos);
    aparelhos = aparelhos.sort((a, b)=>{
      if(a.create < b.create){return 1}
      if(a.create > b.create){return -1}
      return 0;
    });

    let newdata = [];
    let order = {
      'APPLE':1,
      'SAMSUNG':2,
      'MOTOROLA':3,
      'LG':4,
      'HUAWEI':5,
      'POSITIVO':6,
      'ZTE':7
    }

    for(let aparelho of aparelhos){
      let check = newdata.find(e=>e.marca == aparelho.marca);
      if(!check || newdata.length==0){
        let obj = {
          marca:aparelho.marca+'',
          aparelhos:[aparelho],
          order:order[aparelho.marca]
        }
        newdata.push(obj);
      }else{
        check.aparelhos.push(aparelho);
      }
    }

    console.log('newdata',newdata);
    for(let fab of newdata){
      fab.aparelhos = fab.aparelhos.sort((a, b)=>{
        if(a.order < b.order){return -1}
        if(a.order > b.order){return 1}
        return 0;
      });
    }
    this.lista = newdata.sort((a, b)=>{
      if(a.order < b.order){return -1}
      if(a.order > b.order){return 1}
      return 0;
    });
  }

  loadInit(){
    this.insomnia.keepAwake().then(() => console.log('insomnia ok'),() => console.log('insomnia fail'));

    this.backgroundMode.excludeFromTaskList();

    this.platform.registerBackButtonAction(() => {
      this.appMinimize.minimize();
    });

    this.platform.ready().then(() => {
      this.platform.pause.subscribe(() => {
        if(this.readyForeground){
          this.readyForeground=false;
          this.startForeground(15);
        }
      });

      this.platform.resume.subscribe(() => {
        this.stopForeground();
        this.readyForeground=true;
      });
    });
  }

  startForeground(time:any){
    this.localNotifications.schedule({
      id:10,
      title:'Comparativo IBRS',
      text:'Modo degustação',
      priority:2,
      foreground:true
    });
    console.log('Start OK');
    this.runCheck(time);
  }

  stopForeground(){
    clearInterval(this.loopBack);
    this.localNotifications.clear(10);
  }

  runCheck(time:any){
    let timeIntervall = 1000;
    let count = 0;
    let timeSelect = time||15;
    let self = this;
    this.loopBack = setInterval(function(){
      console.log('ok>>',count);
      if(count==timeSelect){
        self.stopForeground();
        self.launch();
      }
      count++;
    },timeIntervall)
  }

  launch(){
    console.log('Open app');
    // this.internalIntent.start();
    this.internalIntent.start(function(){
      console.log('Game started!');
    }, function(err){
      console.log('Game start failed! ', err);
    });
  }

  comparaRenders(){
    if(this.selecionados<1){alert('Selecione um Aparelhos!');return}
    this.navCtrl.push(HomePage,{renders:this.renders});
  }

  filtroRenders(){
    this.navCtrl.push(FilterPage,{renders:this.devices.slice(0,3)});
  }

  selectDev(device,i1,i2){
    let check = this.renders.find(e=>{
      return e.title+'' == device.title+''
    });

    if(check){
      var idx = this.renders.map(e=>e.title).indexOf(device.title);
      this.removeDev(device,idx);
      return;
    }

    if(this.selecionados>=3){alert('Máximo de 3 aparelhos por comparação!');return}

    for(let x1 in this.renders){
      if(this.renders[x1]["title"]=="Selecionar"){
        this.renders[x1]=Object.assign({}, device);
        break;
      }
    }

    this.selecionados++;
    this.lista[i1].aparelhos[i2]["selecionado"] = true;
    this.tools.showAlert('toast',this.lista[i1].aparelhos[i2]["title"]+' adicionado!');
  }

  removeDev(render,index){
    this.renders[index]=this.renderzero;
    this.selecionados--;

    for(var x1 in this.lista){
      for(var x2 in this.lista[x1].aparelhos){
        if(this.lista[x1].aparelhos[x2].title == render.title){
          this.lista[x1].aparelhos[x2].selecionado = false;
          this.tools.showAlert('toast',this.lista[x1].aparelhos[x2].title+' removido!');

        }
      }
    }
    // console.log(check);
  }

}



// WEBPACK FOOTER //
// ./src/pages/lista/lista.ts